export default __webpack_public_path__ + "static/media/arcus-header-logo-cropped.c89eb36a.png";